import BasicReq from './basic';
export default new BasicReq('/season');
